/* feey delivery cutoff — DE store module
 *
 * Single source of truth for DE delivery rules:
 *   - Friday-only delivery
 *   - Wednesday 12:00 Europe/Zurich cutoff for the upcoming Friday
 *   - Block both German federal AND Swiss federal+SG cantonal holidays
 *   - Admin-defined extra blocked dates (Friday or Wednesday-before-Friday)
 *   - Calendar factory (renders into any element, fires onPick callback)
 *
 * Consumed by:
 *   - sections/feey-pers-cart-guard-de.liquid (post-checkout fix-date popup on DE store)
 *
 * Loaded once globally from DE's layout/theme.liquid.
 *
 * NOT used by CH store — CH has its own feey-delivery-cutoff.js with daily 12:00 cutoff
 * and Wed-Sat delivery window. Class prefix `feey-fdc__` is shared between both stores'
 * calendar CSS so the same stylesheet (feey-delivery-calendar.css) styles either one.
 */
(function () {
  if (window.FeeyDeliveryCutoffDe) return;

  // German federal + Swiss federal + St. Gallen cantonal holidays for 2026–2027.
  // (Per feey ops: shipping origin = CH, recipient = DE — both calendars block delivery.)
  // Update annually.
  var STATIC_HOLIDAYS_DE_CH = [
    // 2026 — German federal
    '2026-01-01','2026-04-03','2026-04-06','2026-05-01','2026-05-14','2026-05-25','2026-10-03','2026-12-25','2026-12-26',
    // 2026 — Swiss additions (CH federal + SG cantonal not already in DE list)
    '2026-01-02','2026-08-01','2026-08-15','2026-11-01','2026-12-08',
    // 2027 — German federal
    '2027-01-01','2027-03-26','2027-03-29','2027-05-01','2027-05-06','2027-05-17','2027-10-03','2027-12-25','2027-12-26',
    // 2027 — Swiss additions
    '2027-01-02','2027-08-01','2027-08-15','2027-11-01','2027-12-08'
  ];

  var GERMAN_MONTHS = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
  var GERMAN_DAYS_SHORT = ['So','Mo','Di','Mi','Do','Fr','Sa'];

  function pad2(n) { return ('0' + n).slice(-2); }
  function isoOf(d) {
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
  }
  function startOfDay(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }
  function isoToDdMmYyyy(iso) {
    var p = (iso || '').split('-');
    if (p.length !== 3) return iso || '';
    return p[2] + '/' + p[1] + '/' + p[0];
  }
  function escapeHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  // Get current Zurich Y/M/D/H regardless of visitor's locale.
  // feey ships from Switzerland; cutoff is always Zurich-time.
  // QA override: append `?feey_force_after_noon=1` (or `=before_noon=1`) to any URL.
  function getZurichNow() {
    var z;
    try {
      var fmt = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Zurich',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit',
        hour12: false
      });
      var parts = fmt.formatToParts(new Date());
      var out = {};
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type !== 'literal') out[parts[i].type] = parts[i].value;
      }
      z = {
        year: parseInt(out.year, 10),
        month: parseInt(out.month, 10),
        day: parseInt(out.day, 10),
        hour: parseInt(out.hour, 10)
      };
    } catch (e) {
      var n = new Date();
      z = { year: n.getFullYear(), month: n.getMonth() + 1, day: n.getDate(), hour: n.getHours() };
    }
    try {
      var search = (typeof window !== 'undefined' && window.location && window.location.search) || '';
      if (search.indexOf('feey_force_after_noon=1') !== -1) z.hour = 13;
      else if (search.indexOf('feey_force_before_noon=1') !== -1) z.hour = 9;
    } catch (e2) {}
    return z;
  }

  function getZurichTodayIso() {
    var z = getZurichNow();
    return z.year + '-' + pad2(z.month) + '-' + pad2(z.day);
  }

  function parseAdminBlockedDatesFromText(raw) {
    var out = {};
    if (typeof raw !== 'string') return out;
    var todayIso = getZurichTodayIso();
    var lines = raw.split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var s = lines[i].trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(s) && s >= todayIso) out[s] = true;
    }
    return out;
  }

  // Build a hash of blocked dates: holidays + admin extras + window globals.
  // Inherits any FEY_DE_EXTRA_HOLIDAYS or FEY_SG_EXTRA_HOLIDAYS the existing PDP
  // snippets already use, so admin edits there propagate to our cart-guard.
  function buildBlockedDateSet(adminDates) {
    var s = {};
    for (var i = 0; i < STATIC_HOLIDAYS_DE_CH.length; i++) s[STATIC_HOLIDAYS_DE_CH[i]] = true;
    try {
      if (typeof window !== 'undefined') {
        var globals = ['FEY_DE_EXTRA_HOLIDAYS', 'FEY_SG_EXTRA_HOLIDAYS'];
        for (var g = 0; g < globals.length; g++) {
          var arr = window[globals[g]];
          if (Array.isArray(arr)) {
            for (var gi = 0; gi < arr.length; gi++) {
              if (typeof arr[gi] === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(arr[gi])) {
                s[arr[gi]] = true;
              }
            }
          }
        }
      }
    } catch (e) {}
    if (adminDates) {
      if (Array.isArray(adminDates)) {
        for (var j = 0; j < adminDates.length; j++) s[adminDates[j]] = true;
      } else {
        for (var k in adminDates) if (adminDates.hasOwnProperty(k)) s[k] = true;
      }
    }
    return s;
  }

  // Earliest selectable Friday given the Wednesday 12:00 Zurich cutoff.
  // - Today = Mon, Tue, Wed-before-noon: this Friday eligible
  // - Today = Wed at/after 12:00, Thu, Fri (any time), Sat, Sun: skip to next Friday
  function getNextValidFriday() {
    var z = getZurichNow();
    var todayZ = new Date(z.year, z.month - 1, z.day);
    var dow = todayZ.getDay(); // 0=Sun .. 5=Fri .. 6=Sat

    // "Candidate" Friday = the next upcoming Friday including today
    var daysToFriday;
    if (dow <= 5) daysToFriday = 5 - dow;
    else daysToFriday = 5 - dow + 7;

    var candidateFriday = new Date(todayZ);
    candidateFriday.setDate(todayZ.getDate() + daysToFriday);

    // The Wednesday cutoff for that Friday is 2 days before, at 12:00 Zurich
    var cutoffWed = new Date(candidateFriday);
    cutoffWed.setDate(candidateFriday.getDate() - 2);

    var nowMs = todayZ.getTime();
    var wedMs = cutoffWed.getTime();
    var cutoffPassed;
    if (nowMs > wedMs) cutoffPassed = true;
    else if (nowMs === wedMs) cutoffPassed = (z.hour >= 12);
    else cutoffPassed = false;

    if (cutoffPassed) candidateFriday.setDate(candidateFriday.getDate() + 7);
    return candidateFriday;
  }

  // Friday-or-not check (just weekday)
  function isFriday(d) { return d.getDay() === 5; }

  // Is THIS Friday blocked? Admin can block:
  //   (a) the Friday itself (delivery date unavailable)
  //   (b) the preceding Wednesday (cutoff day unavailable → consequential Friday block)
  function isFridayBlockedByAdmin(fridayDate, blockedDates) {
    if (blockedDates[isoOf(fridayDate)]) return true;
    var wed = new Date(fridayDate);
    wed.setDate(fridayDate.getDate() - 2);
    if (blockedDates[isoOf(wed)]) return true;
    return false;
  }

  // Combined: is this date a valid delivery date?
  function isValidDeliveryDate(d, blockedDates, minFriday) {
    if (!isFriday(d)) return false;
    if (d < minFriday) return false;
    if (isFridayBlockedByAdmin(d, blockedDates)) return false;
    return true;
  }

  // Calendar factory.
  // Same UX as CH (full month grid, weekday header, prev/next nav)
  // but only Fridays are clickable; non-Fridays are visually present but disabled.
  // options:
  //   blockedDates  : { 'YYYY-MM-DD': true, ... }
  //   maxMonthsAhead: number (default 3)
  //   initialIso    : 'YYYY-MM-DD' (optional pre-selection)
  //   onPick        : function(iso, dateLabel) { ... }
  //   classPrefix   : 'feey-fdc' (default; shared CSS)
  function createCalendar(rootEl, options) {
    options = options || {};
    var blockedDates = options.blockedDates || {};
    var maxMonthsAhead = options.maxMonthsAhead || 2;
    var onPick = options.onPick || function () {};
    var classPrefix = options.classPrefix || 'feey-fdc';
    var selectedIso = options.initialIso || '';

    rootEl.innerHTML =
      '<div class="' + classPrefix + '__head">' +
        '<button type="button" class="' + classPrefix + '__nav" data-cal-prev aria-label="Vorheriger Monat">‹</button>' +
        '<span class="' + classPrefix + '__month" data-cal-month></span>' +
        '<button type="button" class="' + classPrefix + '__nav" data-cal-next aria-label="Nächster Monat">›</button>' +
      '</div>' +
      '<div class="' + classPrefix + '__weekdays" aria-hidden="true">' +
        '<span>Mo</span><span>Di</span><span>Mi</span><span>Do</span><span>Fr</span><span>Sa</span><span>So</span>' +
      '</div>' +
      '<div class="' + classPrefix + '__grid" role="grid" data-cal-grid></div>';

    var monthLabel = rootEl.querySelector('[data-cal-month]');
    var grid = rootEl.querySelector('[data-cal-grid]');
    var prevBtn = rootEl.querySelector('[data-cal-prev]');
    var nextBtn = rootEl.querySelector('[data-cal-next]');

    var viewYear = null;
    var viewMonth = null;

    function initView() {
      var minFri = getNextValidFriday();
      if (selectedIso) {
        var p = selectedIso.split('-');
        viewYear = parseInt(p[0], 10);
        viewMonth = parseInt(p[1], 10) - 1;
      } else {
        viewYear = minFri.getFullYear();
        viewMonth = minFri.getMonth();
      }
    }

    function render() {
      if (viewYear === null) initView();
      var minFri = getNextValidFriday();
      var todayIso = getZurichTodayIso();
      // Upper bound: end of (current month + maxMonthsAhead), shown in full
      var _tp = todayIso.split('-');
      var maxDate = new Date(parseInt(_tp[0], 10), parseInt(_tp[1], 10) + maxMonthsAhead, 0);
      monthLabel.textContent = GERMAN_MONTHS[viewMonth] + ' ' + viewYear;

      var firstOfMonth = new Date(viewYear, viewMonth, 1);
      var lastOfMonth = new Date(viewYear, viewMonth + 1, 0);
      var leadEmpty = (firstOfMonth.getDay() + 6) % 7;
      var totalCells = leadEmpty + lastOfMonth.getDate();
      while (totalCells % 7 !== 0) totalCells++;

      var html = '';
      for (var i = 0; i < totalCells; i++) {
        var dayNum = i - leadEmpty + 1;
        if (dayNum < 1 || dayNum > lastOfMonth.getDate()) {
          html += '<button type="button" class="' + classPrefix + '__cell is-empty" tabindex="-1" aria-hidden="true"></button>';
          continue;
        }
        var d = new Date(viewYear, viewMonth, dayNum);
        var iso = isoOf(d);
        var classes = classPrefix + '__cell';
        var ariaLabel = dayNum + '. ' + GERMAN_MONTHS[viewMonth] + ' ' + viewYear;
        // DE blocking rules:
        //   - Not a Friday: blocked
        //   - Friday before minFriday: blocked
        //   - Friday with holiday or Wed-before holiday or admin extra: blocked
        var blocked = !isFriday(d) || d < minFri || d > maxDate || isFridayBlockedByAdmin(d, blockedDates);
        if (blocked) {
          classes += ' is-blocked';
          if (!isFriday(d)) {
            // Quieter style for non-Fridays — just non-clickable, no line-through
            classes += ' is-non-friday';
          } else {
            ariaLabel += ' — nicht verfügbar';
          }
        }
        if (iso === todayIso) classes += ' is-today';
        if (selectedIso === iso) classes += ' is-selected';
        html += '<button type="button" class="' + classes + '"' +
                ' data-cal-day="' + iso + '"' +
                ' aria-label="' + escapeHTML(ariaLabel) + '"' +
                (blocked ? ' aria-disabled="true"' : '') +
                '><span>' + dayNum + '</span></button>';
      }
      grid.innerHTML = html;

      var prevMonthLast = new Date(viewYear, viewMonth, 0);
      prevBtn.disabled = prevMonthLast < minFri;
      var nextMonthFirst = new Date(viewYear, viewMonth + 1, 1);
      nextBtn.disabled = nextMonthFirst > maxDate;

      var cells = grid.querySelectorAll('[data-cal-day]');
      for (var j = 0; j < cells.length; j++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            if (btn.classList.contains('is-blocked') || btn.classList.contains('is-empty')) return;
            var iso = btn.getAttribute('data-cal-day');
            var p = iso.split('-');
            var dt = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
            var dateLabel = GERMAN_DAYS_SHORT[dt.getDay()] + ' ' + dt.getDate() + '.' + (dt.getMonth() + 1) + '.';
            selectedIso = iso;
            for (var k = 0; k < cells.length; k++) {
              cells[k].classList.toggle('is-selected', cells[k] === btn);
            }
            onPick(iso, dateLabel);
          });
        })(cells[j]);
      }
    }

    prevBtn.addEventListener('click', function () {
      if (prevBtn.disabled) return;
      viewMonth -= 1;
      if (viewMonth < 0) { viewMonth = 11; viewYear -= 1; }
      render();
    });
    nextBtn.addEventListener('click', function () {
      if (nextBtn.disabled) return;
      viewMonth += 1;
      if (viewMonth > 11) { viewMonth = 0; viewYear += 1; }
      render();
    });

    initView();
    render();

    return {
      getSelectedIso: function () { return selectedIso; },
      setSelectedIso: function (iso) {
        selectedIso = iso || '';
        if (selectedIso) {
          var p = selectedIso.split('-');
          viewYear = parseInt(p[0], 10);
          viewMonth = parseInt(p[1], 10) - 1;
        }
        render();
      },
      revalidate: function () {
        if (selectedIso) {
          var p = selectedIso.split('-');
          var picked = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
          if (picked < getNextValidFriday()) selectedIso = '';
          else if (isFridayBlockedByAdmin(picked, blockedDates)) selectedIso = '';
        }
        render();
      },
      goToMonth: function (year, month) {
        viewYear = year;
        viewMonth = month;
        render();
      }
    };
  }

  // Export the same shape as CH module so the cart-guard section's code can be
  // near-identical, just with a different namespace name.
  window.FeeyDeliveryCutoffDe = {
    pad2: pad2,
    isoOf: isoOf,
    startOfDay: startOfDay,
    isoToDdMmYyyy: isoToDdMmYyyy,
    escapeHTML: escapeHTML,
    getZurichNow: getZurichNow,
    getZurichTodayIso: getZurichTodayIso,
    getNextValidFriday: getNextValidFriday,
    parseAdminBlockedDatesFromText: parseAdminBlockedDatesFromText,
    buildBlockedDateSet: buildBlockedDateSet,
    isFriday: isFriday,
    isFridayBlockedByAdmin: isFridayBlockedByAdmin,
    isValidDeliveryDate: isValidDeliveryDate,
    createCalendar: createCalendar,
    STATIC_HOLIDAYS: STATIC_HOLIDAYS_DE_CH,
    GERMAN_MONTHS: GERMAN_MONTHS,
    GERMAN_DAYS_SHORT: GERMAN_DAYS_SHORT
  };
})();
